<template>
  <div :class="['segment-menu-container', {active}]">

    <div class="segment-menu-toggle-btn-wrapper">
      <div class="toggle-btn-bg"/>
      <v-btn top depressed  large absolute color="primary" @click="active = !active">
        <v-icon dark>{{active ? 'mdi-close' : 'mdi-menu'}}</v-icon>
      </v-btn>
    </div>

    <div class="menu-overlay"/>

    <div @click="active = !active"  :class="['menu-wrapper pa-6', {active, dark: isDark}]">

      <div class="menu-section pa-4"  :key="`section-${i}`" v-for="(section, i) in allItems">
        <v-list color="transparent" dense width="100%">
          <v-list-item-group  :prepend-icon="section.icon">
            <v-subheader >{{section.title}}</v-subheader>

            <v-list-item v-for="(item, j) in section.items" :to="item.link">
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>

            </v-list-item>
          </v-list-item-group>
        </v-list>
      </div>

    </div>
  </div>
</template>

<script>
import MenuMixin from "../../../mixins/MenuMixin";
import {mapMutations, mapState} from "vuex";

export default {
  name: 'SegmentMenu',
  props: {},
  mixins: [MenuMixin],
  data(){
    return {
      active: false
    }
  },
  mounted() {
    const vm = this;
    document.onkeydown = (e) => {
      if(e.key === "Escape") {
        vm.active = false
      }
    }
  },
  computed: {
    ...mapState(['isDark', 'bgPaused'])
  },
  watch:{
    active(value){
      const vm = this
      vm.setBGPaused(value)
    }
  },
  methods:{
    ...mapMutations(['setBGPaused'])
  }

}

</script>

<style scoped>
.segment-menu-container{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 11;
}

.segment-menu-toggle-btn-wrapper{
  position: fixed;
  top: -10px;
  width: 100%;
  z-index: 10;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toggle-btn-bg{
  position: fixed;
  top: -130px;
  border-radius: 0% 0% 50% 0;
  rotate: 45deg;
  height: 150px;
  width: 150px;
  background-color: var(--v-primary-base);
  z-index: 0;
}

.menu-wrapper{
  pointer-events: none;
  transform: scale(1.05);
  position: fixed;
  backdrop-filter: opacity(0);
  opacity: 0;
  top:0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: center;
  will-change: transform, backdrop-filter, opacity;
  box-shadow: 1px 1px 50px rgba(0,0,0,.7);
  z-index: 2;
}

.menu-overlay{
  pointer-events: none;
  position: fixed;
  background-color: var(--v-background-base);
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  will-change: opacity;
  transition: .3s opacity;
}

.segment-menu-container.active .menu-overlay{
  opacity: .6;
}

.menu-wrapper.active{
  pointer-events: inherit;
  transform: scale(1);
  opacity: 1;
  backdrop-filter: blur(20px);
}

.menu-wrapper .menu-section{
  display: flex;
  margin: 60px 1px 0 1px;
  max-width: 300px;
  z-index: 2;
  flex: 1;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  background-color: rgba(255, 255, 255, .8);
  min-height: 25rem;
  transform: scale(1);
  will-change: transform, box-shadow;
  transition: transform .2s, box-shadow .3s, background-color .3s;
  box-shadow: 3px 3px 10px rgba(0,0,0,.2);
}

.menu-wrapper.dark .menu-section{
  background-color: rgba(0, 0, 0, .5);
}

.menu-wrapper .menu-section:first-child{
  border-radius: 1rem 0 0 1rem;
}

.menu-wrapper .menu-section:last-child{
  border-radius: 0 1rem 1rem 0;
}

.menu-wrapper .menu-section:hover{
  transform: scale(1.02);
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 3px 3px 30px rgba(0,0,0,.5);
}

.menu-wrapper.dark .menu-section:hover{
  background-color: rgba(0, 0, 0, 1);
}

</style>